import { useState, useContext, useEffect } from "react";
import { ReactReduxContext } from 'react-redux';

// Path: Multiple Results
const useGetBasic = (path) => {
  const { store } = useContext(ReactReduxContext);
  const state = store.getState();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (state.api && path) {
      state.api.getFromApi(path, false)
        .then( response => setItems(response.data.results) )
        .catch( e => {
          console.log(`Error useGetBasic`, e);
          setItems([])
        } );
    }
  }, [state.api, path])

  return { items, setItems };
};

export default useGetBasic;
